"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var vector_1 = require("../vector");
var matrix_1 = require("../matrix");
function create(position, halfSize) {
    return {
        position: position,
        halfSize: halfSize
    };
}
exports.create = create;
exports.empty = create(vector_1.Vector2.vec2Zero, vector_1.Vector2.vec2Zero);
function equals(rect1, rect2) {
    return vector_1.Vector2.vec2Equals(rect1.halfSize, rect2.halfSize) && vector_1.Vector2.vec2Equals(rect1.position, rect2.position);
}
exports.equals = equals;
function getWidth(rect) {
    return rect.halfSize.x * 2;
}
exports.getWidth = getWidth;
function getHeight(rect) {
    return rect.halfSize.y * 2;
}
exports.getHeight = getHeight;
function getLeft(rect) {
    return rect.position.x - rect.halfSize.x;
}
exports.getLeft = getLeft;
function getRight(rect) {
    return rect.position.x + rect.halfSize.x;
}
exports.getRight = getRight;
function getTop(rect) {
    return rect.position.y - rect.halfSize.y;
}
exports.getTop = getTop;
function getBottom(rect) {
    return rect.position.y + rect.halfSize.y;
}
exports.getBottom = getBottom;
function getArea(rect) {
    return rect.halfSize.x * rect.halfSize.y * 4;
}
exports.getArea = getArea;
function getCorners(rect) {
    return [
        vector_1.Vector2.vec2Add(rect.position, vector_1.Vector2.vec2Create(rect.halfSize.x, rect.halfSize.y)),
        vector_1.Vector2.vec2Add(rect.position, vector_1.Vector2.vec2Create(rect.halfSize.x, -rect.halfSize.y)),
        vector_1.Vector2.vec2Add(rect.position, vector_1.Vector2.vec2Create(-rect.halfSize.x, -rect.halfSize.y)),
        vector_1.Vector2.vec2Add(rect.position, vector_1.Vector2.vec2Create(-rect.halfSize.x, rect.halfSize.y))
    ];
}
exports.getCorners = getCorners;
function unionBoundingRect(rect1, rect2) {
    if (equals(rect1, exports.empty)) {
        return __assign({}, rect2);
    }
    if (equals(rect2, exports.empty)) {
        return __assign({}, rect1);
    }
    var left = Math.min(getLeft(rect1), getLeft(rect2));
    var right = Math.max(getRight(rect1), getRight(rect2));
    var top = Math.min(getTop(rect1), getTop(rect2));
    var bottom = Math.max(getBottom(rect1), getBottom(rect2));
    return create(vector_1.Vector2.vec2Create((left + right) / 2, (top + bottom) / 2), vector_1.Vector2.vec2Create((right - left) / 2, (bottom - top) / 2));
}
exports.unionBoundingRect = unionBoundingRect;
function unionBoundingVector(point, rect) {
    if (equals(rect, exports.empty)) {
        return create(point, vector_1.Vector2.vec2Zero);
    }
    var left = Math.min(getLeft(rect), point.x);
    var right = Math.max(getRight(rect), point.x);
    var top = Math.min(getTop(rect), point.y);
    var bottom = Math.max(getBottom(rect), point.y);
    return create(vector_1.Vector2.vec2Create((left + right) / 2, (top + bottom) / 2), vector_1.Vector2.vec2Create((right - left) / 2, (bottom - top) / 2));
}
exports.unionBoundingVector = unionBoundingVector;
function transform(matrix, rect) {
    return getCorners(rect).map(function (c) { return matrix_1.Matrix2.apply(c, matrix); }).reduce(function (a, b) { return unionBoundingVector(b, a); }, exports.empty);
}
exports.transform = transform;
function expand(amount, rect) {
    return create(rect.position, vector_1.Vector2.vec2Add(rect.halfSize, vector_1.Vector2.vec2Create(amount, amount)));
}
exports.expand = expand;
function maxOverlapDepth(rect1, rect2) {
    if (equals(rect1, exports.empty) || equals(rect2, exports.empty)) {
        return 0;
    }
    var diff = vector_1.Vector2.abs(vector_1.Vector2.vec2Sub(rect1.position, rect2.position));
    var dist = vector_1.Vector2.vec2Sub(diff, vector_1.Vector2.vec2Add(rect1.halfSize, rect2.halfSize));
    if (dist.x >= -1.0 || dist.y >= -1.0) {
        return 0;
    }
    return Math.max(Math.abs(dist.x), Math.abs(dist.y));
}
exports.maxOverlapDepth = maxOverlapDepth;
